import { render, staticRenderFns } from "./GrowersLayout.vue?vue&type=template&id=61125833&scoped=true&"
import script from "./GrowersLayout.vue?vue&type=script&lang=js&"
export * from "./GrowersLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61125833",
  null
  
)

export default component.exports